export var capitaliseFirstLetter = function(string) {
    return string.replace(/(^|\s|-)([a-z])/g, function(_, leadingWhitespaceOrHyphen, lowercaseLetter) {
        return leadingWhitespaceOrHyphen + lowercaseLetter.toUpperCase();
    });
};
